import React from "react";
import PropTypes from "prop-types";
import { IoIosCloseCircle } from "react-icons/io";
import { IconContext } from "react-icons";

import styles from "./ArchivedCommitteeMember.module.css";

export function ArchivedCommitteeMember({ name, year, onDelete }) {
  return (
    <div className={styles.relative}>
      <div className={styles.archivedMemberContainer}>
        <span>{name}</span>
        <span>{year}</span>
      </div>
      <span className={styles.delete} onClick={() => onDelete(name, year)}>
        <IconContext.Provider
          value={{
            size: "24px",
          }}
        >
          <IoIosCloseCircle />
        </IconContext.Provider>
      </span>
    </div>
  );
}

ArchivedCommitteeMember.propTypes = {
  /**
   * Members name
   */
  name: PropTypes.string,
  /**
   * Year to display
   */
  year: PropTypes.number,
  /**
   * Function called when the X is clicked
   */
  onDelete: PropTypes.func,
};
